import React, { useEffect, useState } from "react";
import { Select, Row, Col, Affix, message } from "antd";
import "./OrderDocuments.css";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/OrderDocuments/Sidebar";
import OrderDocumentsTable from "../../components/OrderDocuments/OrderDocumentsTable";
import Footer from "../../../../common/hoc/withFooter";
import { getOrderById } from "../../../Executorship/Order/redux/actions/orderCard";
import {
  downloadDocument,
  getDocumentsList
} from "../../redux/actions/orderDocuments";
import { API } from "../../../../common/api/constants";
import { RequestService } from "../../../../common/services/RequestService";
import { Button } from "antd";

const OrderDocuments = ({ match, history }) => {
  const dispatch = useDispatch();
  const orderId = match.params.id;
  const order = useSelector(state => state.Executorship.Orders.orderCard.data);
  const tableLoading = useSelector(
    state => state.Lists.documentsList.isLoading
  );
  const documents = useSelector(state => state.Lists.documentsList.documents);
  const [documentsPdf, setDocumentsPdf] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState(null);
  const driver = order && order.driver;
  const driverId = order && order.driverId;
  const responsible = order && order.responsible;
  const responsibleId =
    order && order.responsible && order.responsible.profileId;
  const vehicleId = order && order.vehicleId;
  const vehicle = order && order.vehicle;
  const orderStatusName = order && order.orderStatusName;
  const arrivalDatetime = order && order.arrivalDatetime;

  useEffect(() => {
    dispatch(getDocumentsList(orderId));
    dispatch(getOrderById(match.params.id));
  }, []);

  useEffect(() => {
    initCaption();
  }, [order]);

  useEffect(() => {
    if (documentsPdf) {
      let ieEDGE = navigator.userAgent.match(/Edge/g);
      let ie = navigator.userAgent.match(/.NET/g); // IE 11+
      let oldIE = navigator.userAgent.match(/MSIE/g);
      let blob = new Blob([documentsPdf.data], {
        type: "application/pdf"
      });
      if (ie || oldIE || ieEDGE) {
        window.navigator.msSaveBlob(blob, documentsPdf.key);
      } else {
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      }
    }
  }, [documentsPdf]);

  const goToOrder = () => {
    // ПЕРЕЙТИ К ЗАКАЗУ
    history.push(`/executorship/order/${orderId}`);
  };

  const handleClickRow = record => {
    return {
      onClick: () => {
        RequestService.get(
          `${API}/utility/pdf/orders/${match.params.id}/types/${record.document_type_key}`,
          { responseType: "blob" }
        )
          .then(response => {
            if (response.status === 200) {
              setDocumentsPdf({ ...response, key: record.document_type_key });
            }
          })
          .catch(e => {
            message.error(
              e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : "Ошибка открытия PDF"
            );
          });
      }
    };
  };

  const initCaption = () => {
    const orderNumber =
      order &&
      order.number &&
      order.number.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);

    dispatch(
      setCaption({
        enabled: true,
        mainCaption: orderNumber,
        breadCrumbs: [
          {
            path: "/control-panel",
            breadcrumbName: "Панель управления"
          },
          {
            path: "/executorship/order/" + orderId,
            breadcrumbName: "Заказ - " + orderNumber
          }
        ]
      })
    );
  };

  const onRowSelection = selectedRowKeys => {
    setSelectedDocuments(selectedRowKeys);
  };

  return (
    <>
      <div className={"site-wrapper"}>
        <Row gutter={16} className={"documents-cols"}>
          <Col span={18}>
            <OrderDocumentsTable
              tableLoading={tableLoading}
              data={documents}
              handleClickRow={handleClickRow}
              orderId={orderId}
              orderNumber={order && order.number}
              onRowSelection={onRowSelection}
            />
          </Col>
          <Col span={6}>
            <Affix
              target={() => document.getElementById("mainSheet")}
              offsetTop={24}
            >
              <Sidebar
                driver={{ driver, driverId }}
                vehicle={{ vehicleId, vehicle }}
                responsible={{ ...responsible, responsibleId }}
                orderStatusName={orderStatusName}
                arrivalDatetime={arrivalDatetime}
                goToOrder={goToOrder}
              />
            </Affix>
          </Col>
        </Row>
      </div>
      <Footer className="documents-footer">
        <Button
          type="primary"
          className="documents-footer-button"
          disabled={!selectedDocuments}
          onClick={() => {
            dispatch(
              downloadDocument({
                orderId,
                key: selectedDocuments,
                orderNumber: order && order.number
              })
            );
          }}
        >
          Скачать документы
        </Button>
      </Footer>
    </>
  );
};

export default OrderDocuments;
